import { render, staticRenderFns } from "./TitleBox2.vue?vue&type=template&id=1408f516&scoped=true"
var script = {}
import style0 from "./TitleBox2.vue?vue&type=style&index=0&id=1408f516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1408f516",
  null
  
)

export default component.exports